<div class="emma-switch-or-select">
    <emma-switch
        name="emma_switch_or_select_active"
        [checked]="active"
        (checkedChange)="onChangeSwitch($event)"
        [disabled]="disabled"
        [label]="activeLabel"
    ></emma-switch>
    <div *ngIf="active" [@fadeInOut]>
        <div class="input-group">
            <div class="input-group-slider">
                <emma-slider
                    name="emma_switch_or_slider_value"
                    class="emma-ngx-slider-brand"
                    [(value)]="value"
                    [min]="min"
                    [max]="max"
                    [showTicks]="true"
                    [showTicksValues]="false"
                    [hidePointerLabels]="false"
                    [hideLimitLabels]="true"
                    [tickStep]="tickStep"
                    [disabled]="disabled"
                    [required]="!!required"
                    [getLegend]="getLegend"
                ></emma-slider>
            </div>
            <div class="input-group-text input-group-text-transparent input-group-slider-value">
                <label>
                    {{ slideLabel }}
                    <strong>{{ value }}</strong>
                </label>
            </div>
        </div>
    </div>
</div>
